import React from 'react';

import { Box, Flex } from '@adsk/alloy-react-box';

import { ACTIVITY_VARIANTS } from '../../../../../../constants';

interface PlanTaskEntityActivityCardHeaderProps {
  variant?: typeof ACTIVITY_VARIANTS.ADDED | typeof ACTIVITY_VARIANTS.REMOVED;
}

const PlanTaskEntityActivityCardHeader = ({
  variant,
}: PlanTaskEntityActivityCardHeaderProps) => (
  <Flex alignItems="center">
    <Box
      color={
        variant === ACTIVITY_VARIANTS.ADDED ? 'charcoal900' : 'charcoal700'
      }
      typography={
        variant === ACTIVITY_VARIANTS.ADDED ? 'bodyMediumBold' : 'bodyMedium'
      }
      style={{
        textDecorationLine:
          variant === ACTIVITY_VARIANTS.REMOVED ? 'line-through' : 'none',
      }}
    />
  </Flex>
);

export default PlanTaskEntityActivityCardHeader;
